<template>
  <div class="class-name" ref="classname" style="width:1600px;height:400px">
    <div id="style"></div>
    <svg width="1600" height="400" version="1.1">
      <line data-v-c5f72d12="" data-long="500" data-animation="true"
            x1="0" y1="0" x2="300" y2="400"
            class="animation-1000-1-0" style=" animation-delay: 0ms;"></line>
      <template v-for="(item,index) in list">
        <line style="stroke:#aaa;" v-if="thisDelay>item.delay"
              :x1="item.x1" :y1="item.y1" :x2="item.x2" :y2="item.y2"></line>
        <line :class="'animation'+item.long"
              :style="{animationDuration:item.duration+'ms',animationDelay:item.delay+'ms'}"
              :x1="item.x1" :y1="item.y1" :x2="item.x2" :y2="item.y2"></line>
      </template>
    </svg>
  </div>
</template>

<script type="text/ecmascript-6">
  export default{
    data(){
      return {
        list: [],
        thisDelay: 0
      }
    },

    computed: {},

    created(){
      this.getData();

      let a = setInterval(() => {
        if (this.thisDelay < 25001) {
          this.thisDelay = this.thisDelay + 100;
          //console.log(this.thisDelay);
        } else {
          clearInterval(a);
          a = null;
        }
      }, 100)
    },

    mounted(){
      for (let i = 0; i < this.list.length; i++) {
        let runkeyframes = `@keyframes depict${this.list[i].long}{0%{stroke-dashoffset:${this.list[i].long};stroke: rgba(255,0,0,1);}100%{stroke-dashoffset:0;}}`;
        runkeyframes += ' ';
        runkeyframes += `.animation${this.list[i].long}{stroke-dasharray:${this.list[i].long};animation-name: depict${this.list[i].long};animation-iteration-count:1;}`;
        let style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = runkeyframes;
        document.getElementsByTagName('head')[0].appendChild(style);
      }
    },

    methods: {
      getData(){
        this.list = [
//          {
//            "x1": 57,
//            "x2": 57,
//            "y1": 35,
//            "y2": 35,
//            "millisecond": 1589617033000,
//            "duration": 0,
//            "delay": 0
//          },
          {
            "x1": 57,
            "x2": 57,
            "y1": 35,
            "y2": 35,
            "type": "stay",
            "millisecond": 1589617034000,
            "duration": 5000,
            "delay": 0,
            "long": 3
          },
          {
            "x1": 57,
            "x2": 157,
            "y1": 35,
            "y2": 35,
            "millisecond": 1589617040000,
            "duration": 6000,
            "delay": 1000,
            "long": 1000
          },
          {
            "x1": 157,
            "x2": 157,
            "y1": 35,
            "y2": 45,
            "millisecond": 1589617046000,
            "duration": 6000,
            "delay": 7000,
            "long": 97
          },
          {
            "x1": 157,
            "x2": 157,
            "y1": 45,
            "y2": 45,
            "type": "stay",
            "millisecond": 1589617047000,
            "duration": 1000,
            "delay": 13000,
            "long": 3
          },
          {
            "x1": 157,
            "x2": 161,
            "y1": 45,
            "y2": 70,
            "type": "stay",
            "millisecond": 1589617049000,
            "duration": 1000,
            "delay": 14000,
            "long": 254
          },
          {
            "x1": 161,
            "x2": 186,
            "y1": 70,
            "y2": 70,
            "millisecond": 1589617049333.3333,
            "duration": 333.3333333333333,
            "delay": 16000,
            "long": 251
          },
          {
            "x1": 186,
            "x2": 186,
            "y1": 70,
            "y2": 101,
            "millisecond": 1589617049666.6667,
            "duration": 666.6666666666666,
            "delay": 16333.333251953125,
            "long": 315
          },
          {
            "x1": 186,
            "x2": 159,
            "y1": 101,
            "y2": 100,
            "millisecond": 1589617050000,
            "duration": 1000,
            "delay": 16666.666748046875,
            "long": 270
          },
          {
            "x1": 159,
            "x2": 159,
            "y1": 100,
            "y2": 100,
            "type": "stay",
            "millisecond": 1589617051000,
            "duration": 1000,
            "delay": 17000,
            "long": 3
          },
          {
            "x1": 159,
            "x2": 194,
            "y1": 100,
            "y2": 45,
            "type": "stay",
            "millisecond": 1589617053000,
            "duration": 1000,
            "delay": 18000,
            "long": 646
          },
          {
            "x1": 194,
            "x2": 413,
            "y1": 45,
            "y2": 31,
            "type": "stay",
            "millisecond": 1589617055000,
            "duration": 1000,
            "delay": 20000,
            "long": 2191
          },
          {
            "x1": 413,
            "x2": 270,
            "y1": 31,
            "y2": 30,
            "type": "stay",
            "millisecond": 1589617058000,
            "duration": 2000,
            "delay": 22000,
            "long": 1430
          }
        ];
      }
    },

    components: {}
  }
</script>

<style lang="less" rel="stylesheet/less" scoped="true">
  @-o-keyframes depict-1000-1-0 {
    0% {
      stroke-dashoffset: 500;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  @-webkit-keyframes depict-1000-1-0 {
    0% {
      stroke-dashoffset: 500;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  @-moz-keyframes depict-1000-1-0 {
    0% {
      stroke-dashoffset: 500;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  @keyframes depict-1000-1-0 {
    0% {
      stroke-dashoffset: 500;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .animation-1000-1-0 {
    stroke-dasharray: 500;
    -moz-animation: depict-1000-1-0 50s;
    -o-animation: depict-1000-1-0 50s;
    -webkit-animation: depict-1000-1-0 50s;
    animation: depict-1000-1-0 50s;
    /*animation-duration: 50s;*/
    animation-iteration-count: 1;
  }

  svg {
    background: #ccc;
  }

  svg line {
    /*stroke: rgba(255,0,0,0.1);*/
    stroke-width: 1;
  }

  @keyframes depict {
    from {
      stroke-dashoffset: 50;
    }
    to {
      stroke-dashoffset: 0;
    }
  }

  @keyframes depict-2 {
    from {
      stroke-dashoffset: 50;
    }
    to {
      stroke-dashoffset: 0;
    }
  }

  .animation1 {
    stroke-dasharray: 500;
    animation-name: depict;
    animation-iteration-count: 1;
  }

  .animation2 {
    stroke-dasharray: 50;
    animation-name: depict-2;
    animation-iteration-count: 1;
  }
</style>
